import React from 'react';
import './BatchCard.css';

// `batch`: GET /portal/batch's own shape — { batch_name, branch, batch_year,
// student_count, rank, total_ranked }. `rank: null` is a real, honest state
// (not enough evidence yet), never rendered as "last" or a fake number.
// Rank is shown small and secondary — personal progress stays the headline
// (docs/UI_UX_ARCHITECTURE.md Phase 4 §4/§6).
const BatchCard = ({ batch }) => (
  <div className="z-batch-card">
    <div className="z-batch-name">{batch.batch_name}{batch.branch ? ` · ${batch.branch}` : ''}</div>
    <div className="z-batch-stats">
      <div className="z-batch-stat">
        <span className="z-batch-stat-val">{batch.student_count}</span>
        <span className="z-batch-stat-label">Students</span>
      </div>
      <div className="z-batch-stat">
        <span className="z-batch-stat-val">{batch.rank != null ? `#${batch.rank}` : '—'}</span>
        <span className="z-batch-stat-label">Your Rank</span>
      </div>
    </div>
    {batch.rank == null && (
      <p className="z-batch-note">Rank will appear once enough assessment data is available.</p>
    )}
  </div>
);

export default BatchCard;
